<template>
    <div class="timer-container">
      <svg
        :width="size"
        :height="size"
        :viewBox="`0 0 ${size} ${size}`"
        class="circular-timer"
      >
        <!-- Background circle -->
        <circle
          :cx="center"
          :cy="center"
          :r="radius"
          :stroke-width="strokeWidth"
          class="timer-background"
          fill="none"
          stroke="#e6e6e6"
        />
        
        <!-- Progress circle -->
        <circle
          :cx="center"
          :cy="center"
          :r="radius"
          :stroke-width="strokeWidth"
          class="timer-progress"
          fill="none"
          stroke="#73BC44"
          :stroke-dasharray="circumference"
          :stroke-dashoffset="strokeDashoffset"
          transform="rotate(-90)"
          :transform-origin="`${center}px ${center}px`"
        />
        
        <!-- Timer text -->
        <text
          :x="center"
          :y="center"
          class="timer-text"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          {{ timeLeft }}s
        </text>
      </svg>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CircularCountdown',
    
    props: {
      initialTime: {
        type: Number,
        default: 60
      },
      size: {
        type: Number,
        default: 100
      },
      strokeWidth: {
        type: Number,
        default: 6
      }
    },
    
    data() {
      return {
        timeLeft: this.initialTime,
        intervalId: null
      }
    },
    
    computed: {
      center() {
        return this.size / 2
      },
      
      radius() {
        return (this.size - this.strokeWidth) / 2
      },
      
      circumference() {
        return 2 * Math.PI * this.radius
      },
      
      strokeDashoffset() {
        const progress = (this.initialTime - this.timeLeft) / this.initialTime
        return this.circumference * (1 - progress)
      }
    },
    
    mounted() {
      this.startTimer()
    },
    
    beforeDestroy() {
      this.clearTimer()
    },
    
    methods: {
      startTimer() {
        this.clearTimer()
        this.intervalId = setInterval(() => {
          if (this.timeLeft > 0) {
            this.timeLeft--
          } else {
            this.clearTimer()
            this.$emit('timer-complete')
          }
        }, 1000)
      },
      
      clearTimer() {
        if (this.intervalId) {
          clearInterval(this.intervalId)
          this.intervalId = null
        }
      },
      
      resetTimer() {
        this.timeLeft = this.initialTime
        this.startTimer()
      }
    }
  }
  </script>
  
  <style scoped>
  .timer-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .circular-timer {
    transform: rotate(90deg);
    transform-origin: 50% 50%;
  }
  
  .timer-background {
    transition: stroke 0.3s ease;
  }
  
  .timer-progress {
    transition: stroke-dashoffset 1s linear;
    transform-origin: center;
  }
  
  .timer-text {
    font-size: 36px;
    font-weight: bold;
    fill: #ffffff;
    transform: rotate(-90deg);
    transform-origin: center;
  }
  </style>